'use client';

import * as DS from '@aurorasolar/ds';
import { ComponentProps, ReactNode } from 'react';

type Props = Omit<ComponentProps<typeof DS.Text>, 'as' | 'text'> & { as?: 'h1' | 'h2' | 'h3'; children: ReactNode };

export const D3 = ({ as = 'h2', children, ...props }: Props) => (
  <DS.Text as={as} text={{ _: 'h1', lg: 'd3', md: 'd1' }} {...props}>
    {children}
  </DS.Text>
);
